import { render, staticRenderFns } from "./generalPrintNew.vue?vue&type=template&id=ab3621d0&scoped=true&"
import script from "./generalPrintNew.vue?vue&type=script&lang=js&"
export * from "./generalPrintNew.vue?vue&type=script&lang=js&"
import style0 from "./generalPrintNew.vue?vue&type=style&index=0&id=ab3621d0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab3621d0",
  null
  
)

export default component.exports